import { call, put, takeLatest } from 'redux-saga/effects';
import {
    fetchEntitlementsStart,
    fetchEntitlementsSuccess,
    fetchEntitlementsFailure,
    fetchEntitlementsRequest,
} from '../entitlementsSlice';
import { getEntitlementsApi } from '../../api/apiLists/getEntitlementsApi';
import { callWithAuth } from '../sagaApiHelper';
import { setEntitlementsInStorage } from '../../utils/entitlementsStorage';

function* handleFetchEntitlements() {
    try {
        yield put(fetchEntitlementsStart());
        
        const res = yield call(callWithAuth, getEntitlementsApi, []);

        if (res.status) {
            const entitlements = res.data?.entitlements || [];
            yield put(fetchEntitlementsSuccess(entitlements));
            setEntitlementsInStorage(entitlements);
        } else {
            yield put(fetchEntitlementsFailure(res.errMsg || 'Failed to fetch entitlements'));
        }
    } catch (error) {
        yield put(fetchEntitlementsFailure(error.message || 'An error occurred while fetching entitlements'));
    }
}

function* entitlementsSaga() {
    yield takeLatest(fetchEntitlementsRequest.type, handleFetchEntitlements);
}

export default entitlementsSaga;
